import { Box, Checkbox, Typography } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

const NodeCheckBox = ({
  text = '',
  checked = false,
  onChange,
  disabled = false,
}: {
  text: string
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event)
  }

  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography
        sx={{
          color: isDarkMode ? '#FFFFFF' : '#003F61',
          textAlign: 'right',
          fontFamily: 'Rubik, sans-serif',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 300,
          lineHeight: '100%',
        }}
      >
        {text}
      </Typography>
      {/* nodrag on the box only: a tick must not start a node drag, because a
          pixel of pointer wobble would swallow the click. The label drags. */}
      <Checkbox
        className="nodrag"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        inputProps={{ 'aria-label': text }}
        sx={{ color: isDarkMode ? '#FFFFFF' : undefined }}
      />
    </Box>
  )
}

export default NodeCheckBox
